import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    spacingContainer: {
      [breakpoints.down('md')]: {
        padding: '0px 8px 0px 9px',
      },
      [breakpoints.down(281)]: {
        padding: '0px 8px 85px 8px',
      },
    },
    login: {
      marginBottom: 8,
      '& b': {
        fontWeight: 'bold',
      },
    },
    subtitleLogin: {
      marginBottom: 18,
      fontSize: 14,
    },
    linkContainer: {
      textAlign: 'left',
      marginTop: 5,
    },
    link: {
      color: palette.secondary.main,
      display: 'flex',
      alignItems: 'center',
      fontSize: 12,
      paddingTop: 2,
    },
    arrowIcon: {
      transform: 'rotate(180deg)',
      fontSize: 16,
    },
    qrCodeWrapper: {
      position: 'relative',
      width: 200,
      height: 200,
      border: `1px solid rgba(0,0,0,0.15)`,
      borderRadius: 4,
      margin: '0 0 24px 0',
      paddingBottom: 8,
      overflow: 'hidden',
      fontFamily: 'Roboto',

      '& img': {
        width: '100%',
        height: '100%',
        borderRadius: 4,
      },

      '& figcaption': {
        position: 'absolute',
        bottom: 12,
        left: 0,
        width: '100%',
        textAlign: 'center',
        fontSize: 12,
      },

      '& .qrCodeButton': {
        position: 'absolute',
        top: 0,
        right: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: 'none',
        background: 'rgba(0,0,0,0.3)',
        cursor: 'pointer',
        opacity: 0,
        transition: 'opacity 0.3s',

        '&:after': {
          content: 'attr(data-copy-text)',
          background: palette.white,
          padding: '8px 12px',
          borderRadius: 4,
          fontSize: 14,
        },
      },

      '& .qrCodeButton:focus': {
        background: 'rgba(0, 128, 0, .5)',
        opacity: 1,

        '&:after': {
          content: 'attr(data-copied-text)',
          color: 'rgb(0, 128, 0)',
        },
      },

      '&:hover .qrCodeButton': {
        opacity: 1,
      },
    },
    mfa: {
      '& .MuiOutlinedInput-root': {
        height: 45,
        borderColor: `${palette.darkGray} !important`,
        color: `${palette.darkGray} !important`,
        [breakpoints.down(960)]: {
          color: `${palette.white} !important`,
        },
        '& .MuiOutlinedInput-notchedOutline': {
          [breakpoints.down(960)]: {
            borderColor: `${palette.white} !important`,
            color: `${palette.white} !important`,
          },
        },

        [breakpoints.down('md')]: {
          width: '100%',
        },
      },

      '& .MuiGrid-container': {
        alignItems: 'center',
      },

      '& .MuiFormLabel-root': {
        color: `${palette.darkGray} !important`,
        [breakpoints.down(960)]: {
          borderColor: `${palette.white} !important`,
          color: `${palette.white} !important`,
        },
      },
      '& .MuiOutlinedInput-notchedOutline': {
        [breakpoints.down(960)]: {
          borderColor: `${palette.white} !important`,
          color: `${palette.white} !important`,
        },
      },
      '& .MuiInputBase-root': {
        [breakpoints.down(960)]: {
          color: `${palette.white} !important`,
        },
      },
    },
    loginButton: {
      backgroundColor: palette.deepBlue,
      color: palette.white,
      height: 45,
      fontSize: 12,
      width: '100%',
      [breakpoints.down(350)]: {
        width: '100%',
      },
      '&:hover': {
        backgroundColor: palette.deepBlue,
        color: palette.white,
      },
      '& .MuiCircularProgress-colorPrimary': {
        color: `${palette.offWhite} !important`,
      },
    },
    title: {
      marginBottom: 8,

      '& b': {
        fontWeight: 'bold',
      },
    },
    text: { fontSize: 35 },
  });
